// client/src/hooks/useTrial.js
import { useContext, useState, useEffect } from 'react';
import { AuthContext } from '../context/AuthContext';
import axios from 'axios';

const useTrial = () => {
  const { user, setUser } = useContext(AuthContext);
  const [trialCount, setTrialCount] = useState(user?.trialCount || 0);

  useEffect(() => {
    if (user) {
      setTrialCount(user.trialCount);
    }
  }, [user]);

  const decrementTrial = async () => {
    if (!user || trialCount <= 0) return;

    try {
      const response = await axios.post('/api/user/decrement-trial', {
        userId: user._id,
      });

      setTrialCount(response.data.trialCount);
      setUser(prev => ({ ...prev, trialCount: response.data.trialCount }));
    } catch (error) {
      console.error('Failed to decrement trial count:', error);
    }
  };

  return { trialCount, decrementTrial };
};

export default useTrial;
